import { cn } from '@/lib/utils';
import { Column, Table } from '@tanstack/react-table';
import { ArrowDown, ArrowUp, ArrowUpDown, LucideIcon } from 'lucide-react';
import { ComponentProps } from 'react';
import { Button, ButtonProps } from '../ui/button';

export const ColumnSortableIcon = ({
  column,
  className: _className,
  ...rest
}: { column: Column<any> } & ComponentProps<LucideIcon>) => {
  const sorted = column.getIsSorted();

  const className = cn('ml-2 h-4 w-3', { 'text-emerald-500': !!sorted }, _className);

  if (!sorted) return <ArrowUpDown className={className} {...rest} />;

  return sorted === 'asc' ? (
    <ArrowUp className={className} {...rest} />
  ) : (
    <ArrowDown className={className} {...rest} />
  );
};

/** Single-sortable column */
export const ColumnSortableButton = ({
  column,
  table,
  defaultSort,
  ...rest
}: { table: Table<any>; column: Column<any>; defaultSort?: 'asc' | 'desc' } & ButtonProps) => {
  const sorted = column.getIsSorted();
  const desc = sorted === false ? defaultSort === 'desc' : sorted === 'asc';

  return (
    <Button
      size="sm"
      variant="blurred"
      className="flex items-center gap-x-2 hover:bg-transparent px-0"
      data-sort={sorted || undefined}
      onClick={() => {
        table.setSorting([{ id: column.id, desc }]);
      }}
      {...rest}
    />
  );
};
